a.s.datetimepicker = (function(){
	var my = {
		insert:function(s){
			var el = s.el || undefined;
			var timeformat = s.timeformat || '24h'; // 24h / 12h
			var datetime = s.datetime || undefined;
			var allow_past_date = s.allow_past_date || false;
			var inputname = s.inputname || '';
			var cb_ready = s.ready || function(){};
			var cb_change = s.change || function(){};
			tpl.run({tpl:'/tpl/shared/datetimepicker/main_'+timeformat+'.ejs?v='+v,data:{
				inputname:inputname,
				datetime:datetime,
				allow_past_date:allow_past_date
			},cb:function(content){
				$(el).empty().append(content);
				$(	'input[name="'+inputname+'_date"],'+
					'select[name="'+inputname+'_hours"],'+
					'select[name="'+inputname+'_minutes"],'+
					'select[name="'+inputname+'_ampm"]'
				,el).unbind('change').change(function(){
					my.updateDateTime(s);
				});
				my.updateDateTime(s);
				cb_ready();
			}});
		},
		updateDateTime:function(s){
			var el = s.el || undefined;
			var timeformat = s.timeformat || '24h'; // 24h / 12h
			var inputname = s.inputname || '';
			var cb_change = s.change || function(){};
			var date = $('input[name="'+inputname+'_date"]',el).val();
			var hours = $('select[name="'+inputname+'_hours"]',el).val();
			var minutes = $('select[name="'+inputname+'_minutes"]',el).val();
			var ampm = $('select[name="'+inputname+'_ampm"]',el).val();
			if (timeformat=='24h') {
				var datetime = moment(date+' '+hours+':'+minutes+':00 '+ampm,'YYYY-MM-DD HH:mm:ss');
			}
			else {
				var datetime = moment(date+' '+hours+':'+minutes+':00 '+ampm,'YYYY-MM-DD HH:mm:ss a');
			}
			$('input[name="'+inputname+'"]',el).val(datetime.format("YYYY-MM-DD HH:mm:ss"));
			cb_change();
		}
	}
	return my;
}());